const vehicleModel = {
    aibg:{
      type:"hidden",
      value:"None"
    },
    year:{
      type:"date",
      monthsEnabled: false,
      title: "Vehicle year",
      validators: ["required"],
      propertyName:"vehicle_year",
      uiUpdate:true,
      middleware: "yearMiddleware",
      value:"" // 2008
    },
    manu:{
      type:"select",
      title: "Vehicle make",
      enabled: false,
      options: [],
      validators: ["required"],
      propertyName:"vehicle_make",
      uiUpdate:true,
      middleware: "manuMiddleware",
      value:"" // CHRYSLER
    },
    mkmd:{
      type:"select",
      title: "Vehicle model",
      enabled: false,
      options: [],
      validators: ["required"],
      propertyName:"vehicle_model",
      middleware: "mkmdMiddleware",
      value:"" // SEBRING LIMITED 4DR AWD
    },
    diyr:{
      type:"text",
      title: "Annual (Km)",
      propertyName:"distance_yearly",
      middleware: "crmRecordMiddleware",
      validators: ["required","mustBeNumeric"],
      mask: Number,
      value:"" 
    },
    didl:{
      type:"text",
      title: "Commute to work or school Daily (Km)",
      propertyName:"distance_daily",
      middleware: "crmRecordMiddleware",
      validators: ["required","mustBeNumeric"],
      mask: Number,
      value:"" 
    },
    vicc:{
      type:"hidden",
      title: "VICC",
      options: [],
      validators: ["required"],
      value:"" // 1471
    },
    vice:{
      type:"hidden",
      title: "VICC Extentsion",
      options: [],
      validators: ["required"],
      value:"" // 147100
    },

    puco:{
      type:"select",
      title: "Ownership & Condition",
      propertyName:"ownership_and_condition",
      middleware: "crmRecordMiddleware",
      options: [{value:"YN",name:"Purchased New"},{value:"YU",name:"Purchased Used"},{value:"YD",name:"Purchased Demo"},{value:"LN",name:"Leased New"},{value:"LU",name:"Leased Used"}],
      validators: ["required"],
      value:"" // YD
    },
    pudt:{
      type:"date",
      urlCode: "vehi1_prdt",
      title: "Purchase date",
      propertyName:"purchase_date",
      middleware: "crmRecordMiddleware",
      validators: ["required"],
      value:"" // 20090101
    },
    bdty:{
      type:"hidden",
      value:""
    },
    flTy:{
      type:"hidden",
      value:""
    },
    hybd:{
      type:"hidden",
      value:""
    },
    ncyl:{
      type:"hidden",
      value:""
    },
    vnew:{
      type:"hidden",
      value:""
    },
    prli:{
      type:"hidden",
      value:"Personal"
    },
    loca:{
      type:"hidden",
      value:"RICHMOND HILL"
    },
    loin:{
      type:"hidden",
      value:"609"
    },
    vhty:{
      type:"hidden",
      value:"Private Passenger"
    },
    vhus:{
      type:"hidden",
      value:"Pleasure"
    },
    MVDO:{
      type:"hidden",
      value:"N"
    },
    witi:{
      type:"hidden",
      value:"N"
    },
    cvrgs:{
      values:[
        {
          csio:{value:"TPBI"},
          dedu:{value:""},
          lmt1:{value:"1000000"},
          lmt2:{value:""}
        },
        {
          csio:{value:"TPPD"},
          dedu:{value:""},
          lmt1:{value:"1000000"},
          lmt2:{value:""}
        },
        {
          csio:{value:"44"},
          dedu:{value:""},
          lmt1:{value:"1000000"},
          lmt2:{value:""}
        },
        {
          csio:{value:"UA"},
          dedu:{value:""},
          lmt1:{value:""},
          lmt2:{value:""}
        },
        {
          csio:{value:"AB"},
          dedu:{value:""},
          lmt1:{value:""},
          lmt2:{value:""}
        },
        { // REMOVE ENTUITIVE
          csio:{value:"ACCW"},
          dedu:{value:""},
          lmt1:{value:""},
          lmt2:{value:""}
        },
        {
          csio:{value:"TPDC"},
          dedu:{value:"0"},
          lmt1:{value:""},
          lmt2:{value:""}
        },
        {
          csio:{value:"AP"},
          dedu:{value:"500"},
          lmt1:{value:""},
          lmt2:{value:""}
        },
        {
          csio:{value:"20"},
          dedu:{value:""},
          lmt1:{value:""},
          lmt2:{value:"1200"}
        },
        {
          csio:{value:"27"},
          dedu:{value:""},
          lmt1:{value:"50000"},
          lmt2:{value:""}
        }
      ]
    }
}

export default vehicleModel;